import myzxios from '../utils/myaxios'

export function updateContro(data) {
    return myzxios({
        url: '/manager/CardRoute/updateControlType',
        data,
        method: 'post'
    })
}

export function importChannel(data) {
    return myzxios({
        url: '/manager/CardRoute/importChannel',
        data,
        method: 'post'
    })
}

export function delChannel(data) {
    return myzxios({
        url: '/manager/CardRoute/delChannel/'+data,
        method: 'delete'
    })
}

export function addChannel(data) {
    return myzxios({
        url: '/manager/CardRoute/addChannel',
        data,
        method: 'post'
    })
}

export function getChannelList(data) {
    return myzxios({
        url: '/manager/CardRoute/getChannelList',
        data,
        method: 'post'
    })
}

export function getCardRouteList() {
    return myzxios({
        url: '/manager/getCardRouteList',
    })
}